import type {QueryClient} from '@tanstack/react-query';
import {redirect} from '@tanstack/react-router';
import {keys as identityKeys} from '@/features/identity/lib/keys';
import {isInternalPath} from './internal-path';

export const isUnauthorizedError = (error: unknown): boolean =>
  error instanceof Error && error.name === 'UnauthorizedError';

/**
 * Drop a stale session cache and send the user to `/login`, preserving an
 * internal `next` path so sign-in can restore the original destination.
 */
export const redirectToLogin = async (queryClient: QueryClient, next: string): Promise<never> => {
  await queryClient.invalidateQueries({queryKey: identityKeys.getSession()});
  throw redirect({
    to: '/login',
    search: isInternalPath(next) && next !== '/' ? {next} : {},
    replace: true,
  });
};

export const rethrowUnlessUnauthorized = async (
  error: unknown,
  queryClient: QueryClient,
  next: string,
): Promise<never> => {
  if (isUnauthorizedError(error)) {
    await redirectToLogin(queryClient, next);
  }
  throw error;
};
